import React from 'react';


const NotFound = () => {
  return (
    <div className="not-found bg-gray-300 min-h-screen flex items-center justify-center">
      <div className="bg-red-200 rounded-lg p-8 max-w-md w-full mx-auto text-center">
        <h1 className="text-3xl font-bold mb-4">404 - Page Not Found</h1>
        <p className="text-lg">We're sorry, but the page you're looking for doesn't exist.</p>
      </div>
    </div>
  );
};

export default NotFound;
